const API = `${window.location.origin}/api`;

let adminViewId = null;
export const setAdminView = (id) => { adminViewId = id || null; };
export const getAdminView = () => adminViewId;

export const api = async (path, options = {}) => {
  const url = adminViewId ? `${API}${path}${path.includes("?") ? "&" : "?"}admin_view=${encodeURIComponent(adminViewId)}` : `${API}${path}`;
  const res = await fetch(url, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    let detail = "Something went wrong.";
    try {
      const data = await res.json();
      detail = data.detail || detail;
    } catch (e) {}
    throw new Error(typeof detail === "string" ? detail : "Something went wrong.");
  }
  return res.json();
};

export const CATEGORIES = [
  "Hair & Beauty",
  "Wellness",
  "Food & Catering",
  "Photography & Creative Services",
  "Events",
  "Home & Personal Services",
  "Professional Services",
  "Fitness",
  "Pet Services",
  "Other Service Business",
];

export const COUNTRY_CODES = ["+1", "+44", "+61", "+63", "+91", "+234", "+27", "+254", "+233", "+971",
  "+353", "+52", "+55", "+49", "+33", "+34", "+39", "+92", "+880", "+81"];

export const NOW_TYPES = [
  { value: "availability", label: "Availability" },
  { value: "fully_booked", label: "Fully Booked" },
  { value: "away_closed", label: "Away / Closed" },
  { value: "special_hours", label: "Special Hours" },
  { value: "service_reopening", label: "Service Reopening" },
  { value: "temporary_offer", label: "Temporary Offer" },
  { value: "general_notice", label: "General Notice" },
];

export const POLICY_SUGGESTIONS = {
  "Hair & Beauty": [["consultation", "Consultation"], ["cancellation", "Cancellation"], ["preparation", "Preparation"], ["deposit", "Deposit"], ["late_arrival", "Late arrival"]],
  "Wellness": [["consultation", "Consultation"], ["cancellation", "Cancellation"], ["preparation", "Preparation"], ["deposit", "Deposit"], ["late_arrival", "Late arrival"]],
  "Food & Catering": [["lead_time", "Order lead time"], ["min_order", "Minimum order"], ["pickup_delivery", "Pickup / delivery"], ["cancellation", "Cancellation"], ["dietary", "Dietary / allergen information"]],
  "Photography & Creative Services": [["deposit", "Deposit"], ["rescheduling", "Rescheduling"], ["cancellation", "Cancellation"], ["turnaround", "Turnaround time"], ["delivery_usage", "Delivery / usage information"]],
  "Events": [["deposit", "Deposit"], ["booking_lead_time", "Booking lead time"], ["cancellation", "Cancellation"], ["rescheduling", "Rescheduling"], ["setup_access", "Setup / access requirements"]],
  "Home & Personal Services": [["cancellation", "Cancellation"], ["arrival_access", "Arrival / access information"], ["preparation", "Preparation"], ["deposit", "Deposit"], ["service_area", "Service area"]],
  "Professional Services": [["consultation", "Consultation"], ["cancellation", "Cancellation"], ["payment_terms", "Payment terms"], ["documents", "Documents / preparation needed"], ["response_time", "Response / turnaround time"]],
  "Fitness": [["cancellation", "Cancellation"], ["preparation", "Preparation"], ["health_readiness", "Health / readiness note"], ["late_arrival", "Late arrival"], ["session_requirements", "Session requirements"]],
  "Pet Services": [["cancellation", "Cancellation"], ["dropoff_pickup", "Drop-off / pickup"], ["preparation", "Preparation"], ["vaccination", "Vaccination / health requirements"], ["late_arrival", "Late arrival"]],
  "Other Service Business": [],
};

export const MAX_SERVICES = 12;

export const splitWhatsapp = (raw) => {
  const digits = (raw || "").replace(/\D/g, "").replace(/^00/, "");
  const codes = COUNTRY_CODES.map((c) => c.slice(1)).sort((a, b) => b.length - a.length);
  for (const code of codes) {
    if (digits.startsWith(code) && digits.length > code.length + 3) {
      return { cc: `+${code}`, local: digits.slice(code.length) };
    }
  }
  if (digits.length === 11 && digits.startsWith("1")) return { cc: "+1", local: digits.slice(1) };
  return { cc: "+1", local: digits };
};

export const inputCls =
  "w-full rounded-xl border border-guinep-line bg-white px-4 py-3 text-sm text-guinep-ink outline-none transition-colors focus:border-guinep-mid placeholder:text-guinep-mute/50";

export const labelCls = "mb-1.5 block text-[13px] font-semibold text-guinep-ink";

export const btnPrimary =
  "inline-flex w-full items-center justify-center gap-2 rounded-xl bg-guinep-deep py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-guinep-mid disabled:opacity-50";

export const cardCls = "rounded-2xl border border-guinep-line/70 bg-white";
